export default {
  title: '! Tilaukset keskeytetty klo {{time}} asti',
  button: 'Jatka tilauksia',
  labels: {
    rest_of_day: 'loppupäivä',
  },
};
